import React from 'react';

const FAQBlock = ({ question, answer, answerPartTwo }) => {
  return (
    <div className="w-full md:w-1/2 px-4 mb-10">
      <h2 className="text-shop-dark-green font-sans font-bold text-xl">
        {question}
      </h2>
      <p className="font-sans text-shop-dark-green mt-4 text-base leading-normal">
        {answer}
      </p>
      {answerPartTwo && (
        <p className="font-sans text-shop-dark-green mt-4 text-base leading-normal">
          {answerPartTwo}
        </p>
      )}
    </div>
  );
};

export default FAQBlock;
